import React from 'react';
import PropTypes from 'prop-types';

import { buttons as Buttons } from '@breezeway/brzw-components';

import ConfirmModal from '../confirm_modal';

const RejectButton = ({ onClick }) => (
  <ConfirmModal
    body="Confirm you want to decline doing this task?"
    onConfirm={onClick}
    title="Decline Task"
    cancelButtonText="Not now"
    confirmButtonText="Decline"
  >
    <Buttons.TextButton autoWidth className="text-primary" theme="link">
      Decline
    </Buttons.TextButton>
  </ConfirmModal>
);

RejectButton.propTypes = {
  onClick: PropTypes.func,
};

export default RejectButton;
